module.exports = __webpack_public_path__ + "static/media/combo_5.c4556269.png";